import { useRecaptchaScript } from '../composables/useRecaptchaScript'

export default defineNuxtPlugin(() => {
  const { onError } = useRecaptchaScript()

  onError((error) => {
    console.error('Recaptcha loading script error', error)
  })
})
